import type { PackageStateType } from './types';

export const initialState: PackageStateType = {
  id: 0,
  availability: null,
  extras: [],
  price: 0,
  fuel_charge: 0,
  net_price: 0,
  transfer: false,
  medical_insurance: false,
  previous_price: '0',
  insurable: false,
  misc_data: null,
  instant_confirm: false,
  labels: [],
  cancellation_policy: null,
  confirmability_index: null,
  tour_id: '0',
  dates_info: null,
  surcharge: null,
  adults_count: 0,
  kids_ages: [],
  kids_count: 0,
  pansion: '',
  pansion_description: '',
  pansion_original: '',
  region_name: '',
  operator: null,
  booking_url: null,
  operator_id: 0,
  hotel_id: null,
  request_id: '',
  search_request: null,
  notices: [],
  departure_id: null,
  manual: false,
  original_room: null,
  archived_at: null,
  hot: false,
  arrival_date: null,
  room_type: '',
  search_type: 'package',
  nights_count: 0,
  start_date: null,
};
